<template>
  <footer class="site-footer full-width">
    <div class="footer-content">
      <div class="footer-section">
        <h3>联系我们</h3>
        <div class="contact-info">
          <p><el-icon><Location /></el-icon> 地址：长沙市开福区芙蓉中路一段442号新湖南大厦产业楼</p>
          <p><el-icon><Phone /></el-icon> 电话：0731-8882-6586</p>
          <p class="sitemap-link">
            <router-link to="/sitemap" class="footer-link">
              <el-icon><Menu /></el-icon>
              网站地图
            </router-link>
          </p>
        </div>
      </div>

      <div class="footer-section">
        <h3>关注我们</h3>
        <div class="follow-us">
          <div class="qr-code">
            <div class="qr-wrapper">
              <div class="qr-image">
                <img src="@/assets/images/qrcode1.jpg" alt="微信公众号二维码" />
              </div>
              <p><el-icon><Promotion /></el-icon> 扫码关注公众号</p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="footer-section">
        <h3>企业认证</h3>
        <div class="certifications">
          <p><el-icon><Medal /></el-icon> ISO9001质量管理体系认证</p>
          <p><el-icon><Medal /></el-icon> ISO27001信息安全管理体系认证</p>
          <p><el-icon><Medal /></el-icon> CMMI3级认证</p>
        </div>
      </div> -->
    </div>
    
    <div class="footer-bottom full-width">
      <div class="container full-width">
        <p>
          © {{ new Date().getFullYear() }} 湖南美音网络技术有限公司 版权所有
        </p>
        <p class="beian-info">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">湘ICP备12006597号</a>
          <span class="divider">|</span>
          <a href="http://www.beian.gov.cn" target="_blank" rel="noopener" class="police-beian">
            湘公网安备 43010202000165号
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>


<script setup>
	import {
		ref
	} from "vue"
	import { Location, Phone, Message, Medal, Promotion, Menu } from '@element-plus/icons-vue'
	import {
		useMutitabsStore
	} from "@/store/mutitabs"
	import {
		useRouter
	} from "vue-router"
	import {
		courtGet,
		cityGet
	} from "@/api/court"
	import {
		ElMessage
	} from 'element-plus'
	import { navigationData } from '@/data/navigation' // 导入导航数据

	const router = useRouter()
	const mutitabsstore = useMutitabsStore()
	
	const value1 = ref("")
	const value2 = ref("")
	const value3 = ref("")
	
	const options1 = ref([])
	const options3 = ref([])
	const options2 = ref([])
	
	function gotoManage() {
		if (mutitabsstore.roleNames.includes("管理员")) {
			// 清空所有标签
			mutitabsstore.closeAllTabs()
			// 跳转到后台
			router.push("/index")
		} else if (mutitabsstore.userId) {
			ElMessage.warning("对不起您没有权限进入后台管理界面")
		} else {
			router.push("/login")
		}
	}
	
	function openWindow(path) {
	  window.open(path)
	}
	
	function provinceHandler(url){
		if(!url)return
		openWindow(url)
	}
	
	function cityHandler(id){
		courtGet({
			type:id,
			limit:1000,
		}).then(res => {
			if(res.data.code === 2000){
				options3.value = res.data.data.data
				value3.value = options3.value[0].url
			}
		})
	}
	
	function handler(url){
		if(!url)return
		openWindow(url)
	}
	
	function initPage(){
		courtGet({
			limit:1000,
			type:2
		}).then(res => {
			if(res.data.code == 2000){
				options1.value = res.data.data.data
				// value1.value = options1.value[0].url
			}
		})
		cityGet({
			type:1,limit:1000
		}).then(res => {
			if(res.data.code == 2000){
				options2.value = res.data.data.data
				// value2.value = options2.value[0].id
				// cityHandler()
			}
		})
	}
	
	// 处理子菜单点击
	const handleSubMenuClick = (path) => {
	  if (path.includes('#')) {
	    const [routePath, hash] = path.split('#')
	    if (router.currentRoute.value.path === routePath) {
	      const element = document.getElementById(hash)
	      if (element) {
	        const headerHeight = 80
	        const elementTop = element.offsetTop - headerHeight
	        window.scrollTo({
	          top: elementTop,
	          behavior: 'smooth'
	        })
	      }
	    } else {
	      router.push(path)
	    }
	  } else {
	    router.push(path)
	  }
	}
	
	initPage()
</script>

<style scoped lang="scss">
	.site-footer {
  background: #2c3e50;
  color: #fff;
  padding: 60px 0 0;
  width: 100%;

  .footer-content {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  .footer-section {
    // flex: 0 0 70%;
    text-align: center;

    h3 {
      font-size: 18px;
      margin-bottom: 20px;
      position: relative;
      padding-bottom: 10px;
      text-align: left;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background: #2b5dff;
        transform: none;
      }
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 12px;

        a {
          color: #fff;
          text-decoration: none;
          transition: color 0.3s;

          &:hover {
            color: #2b5dff;
          }
        }
      }
    }

    .contact-info {
      p {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: flex-start;

        .el-icon {
          color: #2b5dff;
          font-size: 18px;
        }
      }

      .sitemap-link {
        margin-top: 15px;
        
        .footer-link {
          display: flex;
          align-items: center;
          gap: 8px;
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s;

          .el-icon {
            color: #2b5dff;
            font-size: 16px;
          }

          &:hover {
            color: #2b5dff;
            transform: translateX(5px);
          }
        }
      }
    }

    .follow-us {
      .qr-code {
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 15px;

        .qr-wrapper {
          display: flex;
          flex-direction: row;
          gap: 15px;
          align-items: center;
          
          .qr-image {
            width: 120px;
            height: 120px;
            border-radius: 8px;
            overflow: hidden;
            flex-shrink: 0;
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          
          p {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            opacity: 0.8;
            margin: 0;
            writing-mode: horizontal-tb !important;
            transform: none !important;
            padding-left: 10px;
            
            .el-icon {
              transform: none !important;
              color: #2b5dff;
              font-size: 18px;
            }
          }
        }
      }
    }

    .certifications {
      p {
        margin-bottom: 15px;
        font-size: 14px;
        opacity: 0.8;
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: flex-start;

        .el-icon {
          color: #2b5dff;
          font-size: 18px;
        }
      }
    }

    .quick-links {
      .footer-link {
        display: flex;
        align-items: center;
        gap: 8px;
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        font-size: 14px;
        transition: all 0.3s;
        margin-bottom: 10px;

        .el-icon {
          color: #2b5dff;
          font-size: 16px;
        }

        &:hover {
          color: #2b5dff;
          transform: translateX(5px);
        }
      }
    }

    &:nth-child(2) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .footer-bottom {
    background: #243342;
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    width: 100%;

    .container {
      width: 100%;
      margin: 0 auto;
      padding: 0 20px;
    }

    p {
      margin: 5px 0;
      opacity: 0.8;
    }

    .beian-info {
      margin: 5px 0;
      opacity: 0.8;

      .divider {
        margin: 0 10px;
        color: rgba(255, 255, 255, 0.3);
      }

      a, .footer-link {
        color: #fff;
        text-decoration: none;
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.8;
        }
      }

      .police-beian {
        position: relative;
        padding-left: 20px;
        
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          background: #fff;
          border-radius: 2px;
          opacity: 0.8;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 40px;
    width: 100%;
    max-width: 100%;
  }
  
  .site-footer {
    width: 100%;
    
    .footer-bottom {
      width: 100%;
      
      .container {
        max-width: 100%;
        width: 100%;
      }
    }
  }
}

@media (max-width: 480px) {
  .footer-content {
    text-align: left;

    .footer-section {
      h3 {
        &::after {
          left: 0;
          transform: none;
        }
      }

      .contact-info p,
      .follow-us .qr-code,
      .certifications p {
        justify-content: flex-start;
      }
    }
  }
}
</style>